import { Link } from 'react-router-dom';

export const forecastedClientsColumns = (filtersRange, monthlyTotals, dataToRender) => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatValue = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '$0.00' : '$' + numberFormatter.format(num);
  };

  const timeRangeColumns = filtersRange?.map((month, index) => {
    return {
      name: month,
      width: '0.5%',
      minWidth: '115px',
      align: 'center',
      footerAlign: 'center',
      // sortable: true,
      render: (cellData, rowData) => {
        const formattedSchedule = rowData?.schedule;
        const value = formattedSchedule[month] || '0.00';
        return formatValue(value);
      },
      footer: formatValue(monthlyTotals[index]),
    };
  });

  const totalsColumn = {
    name: 'Total',
    width: '0.5%',
    minWidth: '115px',
    align: 'center',
    footerAlign: 'center',

    render: (cellData, rowData) => {
      return formatValue(rowData.clientTotal);
    },
    footer: formatValue(dataToRender.reduce((sum, client) => sum + client.clientTotal, 0)),
  };

  const baseColumns = [
    {
      name: 'ID',
      dataKey: 'id',
      width: '0.5%',
      minWidth: '80px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
      defaultSort: { direction: 'asc' },
    },
    {
      name: 'Client',
      dataKey: 'clientName', // ← sort will now use the name
      width: '0.5%',
      minWidth: '300px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
      render: (cellData, rowData) => {
        const clientUrl = `/companiesView/${rowData.id}/details`;
        return (
          <Link
            to={clientUrl}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'inherit',
              cursor: 'pointer',
            }}
          >
            {cellData}
          </Link>
        );
      },
    },
  ];

  return [...baseColumns, ...timeRangeColumns, totalsColumn];
};
